import { HeaderData } from '$core/models/static';
import { ScrollWidthService } from '$core/services/scroll-width.service';
import { HeaderService, StaticStorage } from '$core/services/static';
import {
  createFailureState,
  createIdleState,
  createLoadingState,
  createSuccessState,
  RequestState,
} from '$core/util/state-management/request-state';
import { Component, computed, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Network } from '@ngx-pwa/offline';
import { startWith, Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  protected readonly network = inject(Network);

  private readonly scrollWidthService = inject(ScrollWidthService);
  private readonly staticStorage = inject(StaticStorage);
  private readonly headerService = inject(HeaderService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly staticRequestState =
    signal<RequestState<HeaderData>>(createIdleState());

  private loadSubscription?: Subscription;

  protected readonly headerMenu = computed(
    () => this.staticStorage.static().header
  );

  public get scrollWidht$() {
    return this.scrollWidthService.scrollWidth$;
  }

  public ngOnInit(): void {
    this.staticStorage.langChange$
      .pipe(startWith(null), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (!this.staticStorage.hasActual('header')) {
          this.loadData();
        }
      });
  }

  protected reload(): void {
    this.loadData();
  }

  private loadData(): void {
    this.loadSubscription?.unsubscribe();
    this.staticRequestState.set(createLoadingState());
    this.loadSubscription = this.headerService
      .getHeaderStatics()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: HeaderData) =>
          this.staticRequestState.set(createSuccessState(data)),
        error: (error) =>
          this.staticRequestState.set(createFailureState(error)),
      });
  }
}
